import React, { useEffect, useState } from "react";
import {
  calculateReturnStatement,
  concatenateAndTruncate,
} from "../../Utils/Application-helper";
import { Modal } from "react-bootstrap";
import profile from "../../Assets/Images/undraw_profile.svg";

const SinglePost = ({ post = {}, handleSubmit = null }) => {
  const [modifiedHtmlString, setModifiedHtmlString] = useState("");

  useEffect(() => {
    console.log("=== SINGLE POST COMPONENT ===");
    console.log("Post prop received:", post);
    console.log("Post type:", post?.type);
    console.log("Post URL:", post?.url);
    console.log("Post description:", post?.description);
    console.log("Post object keys:", post ? Object.keys(post) : "No post data");
    console.log("Post object full data:", JSON.stringify(post, null, 2));
  }, [post]);

  useEffect(() => {
    const detectHyperlinks = (text) => {
      const regex = /((https?:\/\/)|(www\.))[^\s<]+/g;

      const modifiedText = text.replace(regex, (url) => {
        let newUrl = url.endsWith("</p>")
          ? url.slice(0, -4)
          : url.endsWith(">")
          ? url.slice(0, -1)
          : url;

        if (!newUrl.startsWith("http://") && !newUrl.startsWith("https://")) {
          newUrl = `https://${newUrl}`;
        }

        return `<a href="${newUrl}" target="_blank">${newUrl}</a>`;
      });

      setModifiedHtmlString(modifiedText);
      return modifiedText;
    };

    if (post?.description) {
      const newModifiedHtml = detectHyperlinks(post?.description);

      const parser = new DOMParser();
      const doc = parser.parseFromString(newModifiedHtml, "text/html");

      const anchorElements = doc.querySelectorAll("a");

      anchorElements.forEach((anchor) => {
        anchor.setAttribute("target", "_blank");
        const href = anchor.getAttribute("href");
        if (href && href.startsWith("www.")) {
          anchor.setAttribute("href", "http://" + href);
        }
      });

      // const modifiedHtmlString = new XMLSerializer().serializeToString(doc);
    }
  }, [post?.description]);

  return (
    <div>
      <Modal.Body>
        <div className="row">
          <div className="col-md-1 ">
            <img
              className="img-profile rounded-circle "
              src={post.pic_url ? post.pic_url : profile}
              alt="profile-pic"
            />
          </div>
          <div className="col-md-10  pl-4">
            <p className="profile-name mb-0 ml-3">{post?.userName || "User"}</p>
            <p className="ml-3">
              {post?.experties &&
                post?.experties.length > 0 &&
                concatenateAndTruncate(post?.experties, 30, "name")}
            </p>
          </div>
        </div>
        <p className="post-tag">
          <span className="post-hour">
            {post.created_at &&
              calculateReturnStatement(new Date(post?.created_at).getTime())}
          </span>
          <p dangerouslySetInnerHTML={{ __html: modifiedHtmlString }} />
        </p>
        {post?.type === "image" && (
          <img src={post.url} className=" w-100" alt="post" />
        )}
        {(post?.type === "video" || post?.type === "reels") && (
          <div>
            {/* Extract video URL from various platforms */}
            {post.url && (
              <div style={{ 
                padding: '15px', 
                background: '#f8f9fa', 
                border: '1px solid #dee2e6',
                borderRadius: '8px',
                marginBottom: '15px'
              }}>
                {(() => {
                  // Helper function to extract clean URL
                  const extractCleanUrl = (url) => {
                    if (url.includes('s3.ap-south-1.amazonaws.com')) {
                      // Extract URL after the S3 prefix
                      const urlParts = url.split('https://');
                      if (urlParts.length > 2) {
                        return `https://${urlParts[2]}`;
                      }
                    }
                    return url;
                  };

                  const cleanUrl = extractCleanUrl(post.url);
                  
                  // Determine platform and display accordingly
                  if (cleanUrl.includes('youtu.be') || cleanUrl.includes('youtube.com')) {
                    return (
                      <>
                        <h6>🎥 YouTube Video</h6>
                        <p><strong>Description:</strong> {post.description}</p>
                        <p><strong>YouTube URL:</strong> 
                          <a href={cleanUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#007bff', textDecoration: 'underline' }}>
                            {cleanUrl}
                          </a>
                        </p>
                        <small className="text-muted">Click the link above to view the YouTube video</small>
                      </>
                    );
                  } else if (cleanUrl.includes('instagram.com') || cleanUrl.includes('instagr.am')) {
                    return (
                      <>
                        <h6>📱 Instagram Video/Reel</h6>
                        <p><strong>Description:</strong> {post.description}</p>
                        <p><strong>Instagram URL:</strong> 
                          <a href={cleanUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#E4405F', textDecoration: 'underline' }}>
                            {cleanUrl}
                          </a>
                        </p>
                        <small className="text-muted">Click the link above to view the Instagram content</small>
                      </>
                    );
                  } else if (cleanUrl.includes('linkedin.com')) {
                    return (
                      <>
                        <h6>💼 LinkedIn Video</h6>
                        <p><strong>Description:</strong> {post.description}</p>
                        <p><strong>LinkedIn URL:</strong> 
                          <a href={cleanUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#0077B5', textDecoration: 'underline' }}>
                            {cleanUrl}
                          </a>
                        </p>
                        <small className="text-muted">Click the link above to view the LinkedIn content</small>
                      </>
                    );
                  } else if (cleanUrl.includes('facebook.com') || cleanUrl.includes('fb.com')) {
                    return (
                      <>
                        <h6>📘 Facebook Video</h6>
                        <p><strong>Description:</strong> {post.description}</p>
                        <p><strong>Facebook URL:</strong> 
                          <a href={cleanUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#1877F2', textDecoration: 'underline' }}>
                            {cleanUrl}
                          </a>
                        </p>
                        <small className="text-muted">Click the link above to view the Facebook content</small>
                      </>
                    );
                  } else if (cleanUrl.includes('tiktok.com')) {
                    return (
                      <>
                        <h6>🎵 TikTok Video</h6>
                        <p><strong>Description:</strong> {post.description}</p>
                        <p><strong>TikTok URL:</strong> 
                          <a href={cleanUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#000000', textDecoration: 'underline' }}>
                            {cleanUrl}
                          </a>
                        </p>
                        <small className="text-muted">Click the link above to view the TikTok video</small>
                      </>
                    );
                  } else {
                    // Generic video or unknown platform
                    return (
                      <>
                        <h6>🎬 Video Content</h6>
                        <p><strong>Description:</strong> {post.description}</p>
                        <p><strong>Video URL:</strong> 
                          <a href={cleanUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#007bff', textDecoration: 'underline' }}>
                            {cleanUrl}
                          </a>
                        </p>
                        <small className="text-muted">Click the link above to view the video content</small>
                      </>
                    );
                  }
                })()}
              </div>
            )}
            
            {/* Fallback video player for direct video files (if URL is a direct video file) */}
            {post.url && !post.url.includes('http') && (
              <video src={post.url} controls className="img-fluid w-100 post-img" />
            )}
          </div>
        )}
      </Modal.Body>
    </div>
  );
};

export default SinglePost;
